import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const msg = formatApiError(err.response?.data?.detail) || "Invalid credentials";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative z-10 min-h-[80vh] flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <p className="overline mb-4">Editor access</p>
        <h1 className="font-serif text-5xl md:text-6xl font-light tracking-tight leading-[1.05]">
          Welcome <span className="italic">back.</span>
        </h1>
        <form onSubmit={onSubmit} className="mt-10 space-y-8">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#66726d]">Email</label>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ghost-input mt-2"
              placeholder="editor@thetealist.com"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#66726d]">Password</label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="ghost-input mt-2"
              placeholder="••••••••"
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <p className="text-sm text-[#1e4a35]" data-testid="login-error">
              {error}
            </p>
          )}
          <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="login-submit-button">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
